export class EquipmentVideoFilterModel {

  contractId!: string;
  device!: string;
  lane!: string;
  date!: Date | null;
  startHour!: Date | null;
  endHour!: Date | null;
  duration!: number;

  constructor() {
    this.date = null;
    this.startHour = null;
    this.endHour = null;
    this.duration = 10;
  }
}
